import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    RacecardHeaderLoader,
    RacecardSecondaryHeaderLoader,
    RacecardRowLoader,
    FirstLineRaceInfo,
    SecondLineRaceInfo,
    SecondaryHeaderLoader,
    PlacehodlerWrapper,
    RacecardSummaryHeaderLoader,
    RaceCardSummaryLoaderWrapper,
    EventRowsLoaderWrapper,
    RacecardHeaderLoaderWrapper,
} from 'src/domains/layouts/shared/loaders';
import { RaceRow } from './RaceRow';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const RaceCardLoader = observer('RaceCardLoader', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { sportsbookVariant } = configState.componentVariants;
    const eventRows = [];

    for (let i = 0; i < 15; i++) {
        eventRows.push(<RaceRow key={i} />);
    }
    return (
        <PlacehodlerWrapper variant={sportsbookVariant}>
            <RacecardHeaderLoaderWrapper variant={sportsbookVariant}>
                <RacecardHeaderLoader variant={sportsbookVariant} />
                <SecondaryHeaderLoader variant={sportsbookVariant} />
                <RacecardRowLoader>
                    <FirstLineRaceInfo variant={sportsbookVariant} />
                    <SecondLineRaceInfo variant={sportsbookVariant} />
                    <SecondLineRaceInfo
                        additional={true}
                        variant={sportsbookVariant}
                    />
                </RacecardRowLoader>
            </RacecardHeaderLoaderWrapper>
            <RaceCardSummaryLoaderWrapper variant={sportsbookVariant}>
                <RacecardSecondaryHeaderLoader variant={sportsbookVariant} />
                <RacecardSummaryHeaderLoader variant={sportsbookVariant} />
                <EventRowsLoaderWrapper variant={sportsbookVariant}>{eventRows}</EventRowsLoaderWrapper>
            </RaceCardSummaryLoaderWrapper>
        </PlacehodlerWrapper>
    );
});
